import { render, staticRenderFns } from "./LuckDrawRecord.vue?vue&type=template&id=68c54e3c&scoped=true&"
import script from "./LuckDrawRecord.vue?vue&type=script&lang=js&"
export * from "./LuckDrawRecord.vue?vue&type=script&lang=js&"
import style0 from "./LuckDrawRecord.vue?vue&type=style&index=0&id=68c54e3c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68c54e3c",
  null
  
)

export default component.exports